<template>
  <div class="page">
    <div class="page-content">

      <page-nav-bar
        currentServiceName="MoneyRoad"
        v-bind:subNavTitle="subNavTitle">
      </page-nav-bar>

      <div class="layoutTop"/>
      <div class="container-fluid">

        <div class="row">
          <div class="col-md-10 offset-md-1">
            <f7-list v-if="this.capsule === 'draft-edit'" class="draftTitle">
              <f7-list-item>
                <f7-label class="paymentsRequestSubOption formLabel formLabelPayment"><span class="color-red">* </span>Draft name</f7-label>
                <f7-input class="paymentsRequestSubOption" placeholder="Draft name" type="text" v-model="draftName"></f7-input>
              </f7-list-item>
            </f7-list>
          </div>
        </div>

      <div class="row">
            <div class="col-md-10 offset-md-1">
              <div class="panel21 panel-default">
                <div class="panel-heading">
                    <h6 class="content-block labelAccordionForm creationFormTitle">
                        <img src='../../../assets/static/images/icons/inbox_out.png' class="formIcon"/>
                        New Request to Pay
                    </h6>
                </div>

                <div class="accordion-item accordionForm">
                  <a href="#" class="item-content item-link" @click="rotateChevron($event)">
                    <div class="item-inner" v-bind:class="colorBottomButton">
                      <div class="form-group row justify-content-start">
                          <div class="item-title createInvoiceBand col-sm-auto">
                            INVOICE
                            <i class="f7-icons formChevron">chevron_right</i>
                          </div>
                      </div>
                    </div>
                  </a>

                  <div class="accordion-item-content">
                      <div class="row">
                        <div class="form-group col-sm-12">
                          <label class="col-form-label labelAccordionForm">
                            Invoice
                          </label>
                          <div class="row" :class="colorBottomButton">
                            <div class="form-group col-6">
                              <f7-button class="button-inner-color button-round invoiceButton buttonAccordionForm"
                                         @click="openImportAttachmentInvoice()">
                                {{ $t('attachments.import_invoice') }}
                              </f7-button>
                            </div>
                            <div class="form-group col-6">
                              <f7-button class="button-round button-inner-color invoiceButton buttonAccordionForm scanbutton" @click="scanInvoice($event)">
                                {{ $t('creation_forms.scan_invoice_form') }}</f7-button>
                            </div>
                          </div>
                          <div class="row">
                            <div class="form-group col-6">
                              <input class="form-control inputAccordionForm" type="text"
                                placeholder="Select a file..."
                                readonly
                                id="application-file-input"
                                v-model="attachementNameLabel"></input>
                              <input class="item-input hiddenElementAllSize local-file-input" @change="onFileChange" type="file"/>
                              <input class="hiddenElementAllSize" type="text"></input>
                              <input class="hiddenElementAllSize" type="text" id="recommendation-list-input"></input>
                            </div>

                            <div class="col-sm-4"  v-if="attachementName !== ''" :class="colorBottomButton">
                              <f7-button class="button-round button-inner-color invoiceButton buttonAccordionForm" @click="clearInvoice()">Clear</f7-button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row" v-if="attachementName !== ''">
                        <label class="col-4 col-sm-2 col-form-label labelAccordionForm">
                          Reference
                        </label>
                        <div class="col-8 col-sm-10">
                          <input
                            class="form-control inputAccordionForm"
                            placeholder="Reference"
                            type="text"
                            v-model="attachementReference">
                          </input>
                        </div>
                      </div>
                    </div>
                  </div>
              <hr/>

        <div class="accordion-item accordionForm">
            <a href="#" class="item-content item-link" @click="rotateChevron($event)">
              <div class="item-inner" v-bind:class="colorBottomButton">
                <div class="form-group row justify-content-start">
                    <div class="item-title createInvoiceBand col-sm-auto">
                      RECIPIENT LIST
                      <i class="f7-icons formChevron">chevron_right</i>
                    </div>
                </div>
              </div>
            </a>

            <div class="accordion-item-content">
                <div class="form-group row justify-content-start">
                <div class="col-sm-6" v-bind:class="colorBottomButton">
                  <a href="/payments/contactDebtorList/">
                    <span href="#" class="button button-round button-inner-color">
                        {{ $t('sent.select_cntct_btn',
                          {contacttype: this.$i18n.t(this.$engine.services.getLabelIdOne(this.$engine.user.currentService.id))}) }}
                    </span>
                  </a>
                </div>
                <div class="test-title subtitleDebtorList col-sm-4 col-form-label labelAccordionForm" v-bind:class="{redFont: debtorListColor}">
                  {{this.selected.length}} debtor(s) selected
                </div>
                <div class="col-sm-4" v-if="isOcrActive === true" v-bind:class="colorBottomButton">
                  <input class="item-input hiddenElementAllSize rib-file-input" @change="executeOCROnRIB" type="file"/>
                  <f7-button
                    class="button-round button-inner-color attachmentButton buttonAccordionForm"
                    @click="importRIB($event)" >
                    {{ $t('sent.import_RIB_btn',
                      {contacttype: this.$i18n.t(this.$engine.services.getLabelIdOne(this.$engine.user.currentService.id))}) }}
                  </f7-button>
                </div>
              </div>

                <div class="form-group row">
                  <label class="col-sm-12 col-form-label labelAccordionForm">
                    <div class="grayEmpty">
                    </div>
                    <div>
                      <div class="subtitleDebtorList" v-bind:class="{redFont: debtorListColor}">Add Other Debtor</div>
                    </div>
                  </label>
                </div>

                <div class="row">
                  <form-write-group-label-input :isMandatory="true"
                    :idLabel="$t('common.nme')" :placeholderValue="$t('common.debtor_name')"
                    v-model="debtorName">
                  </form-write-group-label-input>
                  <form-write-group-label-input :isMandatory="true"
                    :idLabel="$t('common.idtfr')" :placeholderValue="$t('common.debtor_email')"
                    v-model="debtorEmail">
                  </form-write-group-label-input>
                </div>



                <div class="row">
                  <form-write-group-label-input :isMandatory="true"
                    :idLabel="$t('bank_accounts.bank_account_singular')" :placeholderValue="$t('common.debtor_iban')"
                    v-model="debtorBank">
                  </form-write-group-label-input>

                  <div class="col-sm-6 form-group centraliseDebtorButtons">
                    <div class="row">
                      <div class="form-group col-sm-6" v-bind:class="colorBottomButton">
                        <div class="paymentsRequestAddOtherDebtor">
                          <a href="/payments/debtorList/" class="button button-round button-inner-color">
                            {{this.enteredDebtors.length}} debtor(s) added
                          </a>
                        </div>
                      </div>
                      <div class="form-group col-sm-6" v-bind:class="colorBottomButton">
                        <div class="paymentsRequestAddOtherDebtor" @click="addDebtor">
                          <a href="#" class="button button-round button-inner-color">
                            Add to request
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
        </div>
<hr />

    <div class="accordion-item accordionForm">
      <a href="#" class="item-content item-link" @click="rotateChevron($event)">
        <div class="item-inner" v-bind:class="colorBottomButton">
          <div class="form-group row justify-content-start">
              <div class="item-title createInvoiceBand col-sm-auto">
                MY ACCOUNT INFORMATION
                <i class="f7-icons formChevron">chevron_right</i>
              </div>
          </div>
        </div>
      </a>

      <div class="accordion-item-content">
        <div class="row">
          <div class="col-sm-6 form-group">
            <label class="createInvoiceBand">
              {{ $t("bank_accounts.my_account") }}
            </label> <span class="color-red">* </span>
            <div class="showSmallScreenOnly form-group" :class="colorBottomButton">
              <div @click="accountPicker($event)" class="button button-round button-inner-color buttonAccordionForm">
                Select
              </div>
            </div>
            <div class="showSmallScreenOnly">
              <input class="form-control" id="account-inputDP" type="text" v-model="creditorBankName" placeholder="Select an account ..." readonly></input>
            </div>
            <div class="showLargeScreenOnly">
              <select class="form-control" id="sel2" readonly v-model="creditorBank">
                <option value="">Select an account ...</option>
                <option v-for="bankAccount in bankAccounts" :key="bankAccount.id" :value="bankAccount.iban"> {{bankAccount.name}}</option>
              </select>
            </div>
          </div>
        </div>
      </div>
  </div>
<hr/>
    <div class="accordion-item accordionForm">
      <a href="#" class="item-content item-link" @click="rotateChevron($event)">
        <div class="item-inner" v-bind:class="colorBottomButton">
          <div class="form-group row justify-content-start">
              <div class="item-title createInvoiceBand col-sm-auto">
                <div v-if="directPayments === '1'">
                  DIRECT PAYMENT DETAILS
                  <i class="f7-icons formChevron">chevron_right</i>
                </div>
                <div v-else>
                  REQUEST TO PAY DETAILS
                  <i class="f7-icons formChevron">chevron_right</i>
                </div>
              </div>
          </div>
        </div>
      </a>

      <div class="accordion-item-content hasDatePicker">
        <div class="row">
          <form-write-group-label-input :isMandatory="true"
            :idLabel="$t('common.rsn')" :placeholderValue="$t('common.rsn')"
            v-model="remittanceInformation">
          </form-write-group-label-input>
          <form-write-group-label-input :isMandatory="true"
            :idLabel="$t('common.date_label')" :placeholderValue="$t('common.slct_date')"
            v-model="executionDate" :inputType="'date'">
          </form-write-group-label-input>
        </div>

        <div class="form-group row">
          <form-write-group-label-input :isMandatory="true"
            :idLabel="$t('common.amnt')" :placeholderValue="$t('common.amnt')"
            v-model="amount" :inputType="'number'">
          </form-write-group-label-input>
          <div class="col-sm-6 centraliseCheckBox" v-if="directPayments === '0'">
            <b-form-checkbox
              v-model="modificationAccepted"
              :value="true"
              :unchecked-value="false"
              id="modificationAcceptedCheckbox"
              >
              <label for="modificationAcceptedCheckbox" class="labelAccordionForm">
                Creditor may negotiate
              </label>
            </b-form-checkbox>
          </div>
        </div>
      </div>
    </div>
</div>
</div>
</div>

    <div class="row justify-content-start" v-bind:class="colorBottomButton">
      <div class="col-md-3 offset-md-1">
        <button round
        v-bind:class="savePosition"
        class="button-action firstButtonMarginTop"
          @click="getNameDraft">
          <i class="icon fa fa-save"></i>
          Save Request
        </button> <!-- v-if="clearance === '1' | clearance === '2'" -->
      </div>
      <div class="col-md-3 offset-md-4">
        <button round
        v-if="clearance === '1' | clearance === '2'"
        class="button-action firstButtonMarginTop"
         @click="sendPayments">
          <i class="icon fa fa-paper-plane"></i>
          Send Request
        </button>
      </div>
    </div>

    </div>
      <f7-button class="button-round orangeConfirmationButton"
        @click="sendDirectPayments"
        v-if="directPayments === '1'">
          Send Direct Payments
      </f7-button>
      <div class="toolbarPageBottomBlank"></div>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import * as JsPDF from 'jspdf'
import {errorMessageAlert} from '@/helpers/alert'
import pageNavBar from '@/components/common/pageNavBar.vue'
import {validateIBAN} from '@/helpers/validator'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import datePickerMixin from '@/mixins/datePickerMixin'
import {loadPage} from '@/helpers/routing'
import formWriteGroupLabelInput from '@/components/common/formWriteGroupLabelInput.vue'

export default {
  mixins: [datePickerMixin],
  name: 'writePayments',
  props: ['subNavTitle', 'capsule', 'saveMessage'],
  components: {
    JsPDF,
    'page-nav-bar': pageNavBar,
    'bottom-toolbar': bottomToolbar,
    'form-write-group-label-input': formWriteGroupLabelInput
  },
  data () {
    return {
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      debtorName: '',
      debtorBank: '',
      debtorEmail: '',
      debtorZoneCode: '',
      creditorBank: '',
      creditorBankName: '',
      remittanceInformation: '',
      executionDate: '',
      amount: '',
      modificationAccepted: false,
      isOcrActive: false,
      attachement: '',
      attachementId: '',
      attachementName: '',
      attachementReference: '',
      loadingFile: false,
      fromCloud: false,
      bankAccounts: [],
      contacts: [],
      contactSelectionList: [],
      contactsObject: {},
      cloudFiles: [],
      ImmPmtAccepted: false,
      cloudDocsPicker: '',
      contactsPicker: '',
      accountsPicker: '',
      selected: [],
      selectedDebtors: {},
      enteredDebtors: [],
      sendPaymentsClicked: false,
      directPayments: '0',
      idDraft: '',
      clearance: '',
      draftName: '',
      contactSelected: false,
      hasCloudAttachments: false
    }
  },
  computed: {
    attachementNameLabel () {
      if (this.attachementName === '') {
        return 'Select a file...'
      } else {
        return this.attachementName
      }
    },
    debtorListColor () {
      // TLV 14/10/2019 Si l'un des 3 champs du formulaire de recipient est vide, que moins d'un utilisateur a été entré et que l'utilisateur a cliqué, la coloration passe en rouge
      return (this.debtorName === '' | this.debtorEmail === '' | this.debtorBank === '') && this.sendPaymentsClicked && this.enteredDebtors.length < 1
    },
    creditorColor () {
      return this.creditorBankName === '' && this.sendPaymentsClicked
    },
    remittanceInformationColor () {
      return this.remittanceInformation === '' && this.sendPaymentsClicked
    },
    executionDateColor () {
      return (this.executionDate === '' || this.executionDate === 'Invalid date') && this.sendPaymentsClicked
    },
    amountColor () {
      return this.amount === '' && this.sendPaymentsClicked
    },
    savePosition: function () {
      return {
        leftfav: this.clearance === '1' | this.clearance === '2'
      }
    }
  },
  mounted () {
    /* TLV 18/12/2019
    * Les accordéons sont étendus par défaut, quelque soit le support
    */
    this.$$('.accordionForm').addClass('accordion-item-expanded')
    this.$$('.formChevron').transform('rotate(90deg)')
    this.$engine.services.payments.contactDebtorList = []
  },
  created () {
    let that = this

    if (this.$engine.settings.get().ocrActivation === '1') {
      that.isOcrActive = true
    }
    this.$f7.params.swipePanel = that.$engine.services.directPayments.filter.smartphoneStorage ? 'left' : false
    this.$f7.params.panelsCloseByOutside = that.$engine.services.directPayments.filter.smartphoneStorage
    this.$bus.$on('refresh-contact-payments', (data) => {
      this.debtorName = data.debtorName
      this.debtorBank = data.debtorBank
      this.debtorEmail = data.debtorEmail
    })
    this.enteredDebtors = this.$engine.services.payments.debtorList
    // TODO : selected
    // this.selected = this.$engine.services.payments.contactDebtorList
    this.selected = []
    this.$engine.services.payments.contactDebtorList = []
    this.$engine.services.payments.contactGroupsSelected = []
    // this.contacts = this.$settings.currentAccount.contacts
    this.contacts = this.$engine.contacts.get()
    for (var i = 0; i < that.contacts.length; i++) {
      that.contactsObject[that.contacts[i].id] = that.contacts[i]
    }
    this.setContacts()
    // Get default value for Negotiation
    this.modificationAccepted = this.$engine.settings.get().defaultNegotiationAllowed === '1'
    if (this.capsule === 'draft-edit') {
      this.$bus.$on('refresh-debtor-contact-list', (data) => {
        that.selected = data[0]
        that.selectedDebtor = {}
        that.selectedDebtor = that.contactsObject[this.selected]

        that.debtorName = that.selectedDebtor.name
        that.debtorEmail = that.selectedDebtor.identifier
        that.debtorBank = that.selectedDebtor.iban
        that.contactSelected = true
      })
    } else {
      this.$bus.$on('refresh-debtor-contact-list', (data) => {
        that.selected = data
        that.selectedDebtors = {}
        for (var i = 0; i < that.selected.length; i++) {
          that.selectedDebtors[that.selected[i]] = that.contactsObject[this.selected[i]]
          // this.selectedDebtors.push(this.contactsObject[this.selected[i]])
        }
        that.contactSelected = true
      })
    }
    // this.bankAccounts = this.$settings.currentAccount.ibans
    // this.cloudFiles = this.$settings.currentAccount.docs
    this.bankAccounts = this.$engine.bankAccounts.get()

    this.loadingFile = false
    this.fromCloud = false
    // this.executionDate = moment().format('YYYY-MM-DD')
    this.executionDate = ''
    this.creditorBank = ''
    this.creditorBankName = ''
    that.attahmentName = 'File'
    if (typeof (this.$settings.preChargedFile) !== 'undefined') {
      if (this.$settings.preChargedFile.fromCloudList === true) {
        this.fromCloud = true
        this.attachementId = this.$settings.preChargedFile.id
        this.attachementName = this.$settings.preChargedFile.name
        this.attachement = this.$settings.preChargedFile.data
        this.attachementReference = this.$settings.preChargedFile.reference
        this.amount = this.$settings.preChargedFile.amount
        this.executionDate = this.$settings.preChargedFile.executionDate
        this.debtorName = this.$settings.preChargedFile.debtorName
        this.debtorEmail = this.$settings.preChargedFile.debtorEmail
        this.debtorBank = this.$settings.preChargedFile.debtorBankAccount
        this.remittanceInformation = this.$settings.preChargedFile.remittanceInformation
        if (this.debtorName !== '' && this.debtorEmail === '') {
          for (i = 0; i < this.contacts.length; i++) {
            if (this.contacts[i].name === this.$settings.preChargedFile.debtorName) {
              that.debtorName = this.contacts[i].name
              that.debtorBank = this.contacts[i].iban
              that.debtorEmail = this.contacts[i].identifier
            }
          }
        }
      }
    }
    this.$settings.preChargedFile = undefined
    if (typeof (this.$settings.preChargedDraft) !== 'undefined') {
      for (let i = 0; i < this.bankAccounts.length; i++) {
        if (this.bankAccounts[i].iban === this.$settings.preChargedDraft.CreditorBankAccount) {
          this.creditorBankName = this.bankAccounts[i].name
        }
      }

      if (this.$settings.preChargedDraft.AttacAttachmentIdhmentName !== '') {
        this.attachementId = this.$settings.preChargedDraft.AttachmentId
      }
      if (this.$settings.preChargedDraft.AttachmentName !== '') {
        this.attachementName = this.$settings.preChargedDraft.AttachmentName
      }
      if (this.$settings.preChargedDraft.Attachment !== '' && this.$settings.preChargedDraft.Attachment !== '$NotFound') {
        this.attachement = this.$settings.preChargedDraft.Attachment
      }
      if (this.$settings.preChargedDraft.AttachmentReference !== '') {
        this.attachementReference = this.$settings.preChargedDraft.AttachmentReference
      }
      if (this.$settings.preChargedDraft.DebtorName !== '') {
        this.debtorName = this.$settings.preChargedDraft.DebtorName
      }
      if (this.$settings.preChargedDraft.DebtorBankAccount !== '') {
        this.debtorBank = this.$settings.preChargedDraft.DebtorBankAccount
      }
      if (this.$settings.preChargedDraft.DebtorIdentifier !== '') {
        this.debtorEmail = this.$settings.preChargedDraft.DebtorIdentifier
      }
      if (this.$settings.preChargedDraft.CreditorBankAccount !== '') {
        this.creditorBank = this.$settings.preChargedDraft.CreditorBankAccount
      }
      if (this.$settings.preChargedDraft.RemittanceInformation !== '') {
        this.remittanceInformation = this.$settings.preChargedDraft.RemittanceInformation
      }
      if (this.$settings.preChargedDraft.RequestedExecutionDate !== '') {
        this.executionDate = this.$settings.preChargedDraft.RequestedExecutionDate
      }
      if (this.$settings.preChargedDraft.Amount !== '') {
        this.amount = this.$settings.preChargedDraft.Amount
      }
      if (this.$settings.preChargedDraft.ModificationAccepted === 'true') {
        this.modificationAccepted = true
      } else if (this.$settings.preChargedDraft.ModificationAccepted === 'false') {
        this.modificationAccepted = false
      }
      if (this.$settings.preChargedDraft.draftName !== '') {
        this.draftName = this.$settings.preChargedDraft.draftName
      }
      this.idDraft = this.$settings.preChargedDraft.idDraft
      this.ImmPmtAccepted = this.$settings.preChargedDraft.ImmPmtAccepted
    }
    this.$settings.preChargedDraft = undefined

    let contactsMap = this.contacts.map(function (obj) {
      let rObj = {}
      rObj[obj.label] = obj
      return rObj
    })
    let contactsMapObj = Object.assign({}, ...contactsMap)
    this.contactsPicker = this.$f7.picker({
      input: '#bookContacts',
      rotateEffect: true,
      cols: [
        {
          textAlign: 'center',
          values: Object.keys(contactsMapObj)
        }
      ],
      onClose: function (p) {
        // var data = []
        that.debtorName = contactsMapObj[p.value].name
        that.debtorBank = contactsMapObj[p.value].iban
        that.debtorEmail = contactsMapObj[p.value].identifier
        that.contacts = contactsMapObj[p.value]
      }
    })
    let ibansMap = this.bankAccounts.map(function (obj) {
      let rObj = {}
      rObj[obj.name] = obj.iban
      return rObj
    })
    let ibansMapObj = Object.assign({}, ...ibansMap)
    /* TLV 11/12/2019
    * Un message est affiché si l'utilisateur n'a aucune banque
    */
    let bankaccountvalues = Object.keys(ibansMapObj)
    let displaybankaccountValues = bankaccountvalues
    let cssClass = ''
    if (bankaccountvalues.length === 0) {
      bankaccountvalues = ['']
      displaybankaccountValues = ['']
      cssClass = 'italicPicker'
    }
    this.accountsPicker = this.$f7.picker({
      input: '#account-input',
      rotateEffect: true,
      cols: [
        {
          textAlign: 'center',
          values: bankaccountvalues,
          displayValues: displaybankaccountValues,
          cssClass: cssClass
        }
      ],
      onClose: function (p) {
        that.creditorBank = ibansMapObj[p.value]
        that.creditorBankName = p.value
      }
    })

    let params = {
      idAcct: this.$engine.user.get().id
    }
    that.$engine.attachments.getRefresh(params).then(response => {
      this.cloudFiles = response.data.docs
      let filesMap = this.cloudFiles.map(function (obj) {
        let rObj = {}
        rObj[obj.name] = {id: obj.id, name: obj.name, type: obj.type, internalReference: obj.internalReference}
        return rObj
      })
      let filesMapObj = Object.assign({}, ...filesMap)
      let values = []
      if (Object.keys(filesMapObj).length > 0) {
        values = Object.keys(filesMapObj)
        this.hasCloudAttachments = true
      } else {
        values = ['Nothing Found']
      }

      this.cloudDocsPicker = this.$f7.picker({
        input: '#application-file-input',
        rotateEffect: true,
        cols: [
          {
            textAlign: 'center',
            values: values
          }
        ],
        onClose: function (p) {
          if (Object.keys(filesMapObj).length > 0) {
            if (filesMapObj[p.value].id !== that.attachementId) {
              that.attachementId = filesMapObj[p.value].id
              that.cloudFileSel()
            }
          }
        },
        onOpen: function (p) {
          if (Object.keys(filesMapObj).length > 0) {
            that.attachementName = p.value
          }
        }
      })
    })
    .catch(err => {
      errorMessageAlert(err, that)
    })
    this.clearance = this.$engine.user.get().clearance['Payments']
  },
  beforeDestroy () {
    this.attachementName = ''
    this.attachment = ''
    this.debtorName = ''
    this.debtorBank = ''
    this.creditorBank = ''
    this.debtorEmail = ''
    this.remittanceInformation = ''
    this.executionDate = ''
    this.amount = ''
    this.attachementReference = ''
    this.modificationAccepted = false
    this.attachementId = ''
    this.loadingFile = ''
    this.fromCloud = ''
    this.bankAccounts = ''
    this.contacts = []
    this.cloudFiles = []
    this.ImmPmtAccepted = false
    this.cloudDocsPicker = ''
    this.accountsPicker = ''
    this.draftName = ''
    this.$engine.services.payments.debtorList = []
    this.$engine.services.payments.contactDebtorList = []

    let attachmentObj = {
      fromCloudList: false,
      id: 0,
      name: '',
      data: '',
      amount: 0,
      reference: '',
      debtorName: '',
      executionDate: ''
    }
    let draftObj = {
      Amount: '',
      AttachmentId: '',
      AttachmentName: '',
      AttachmentReference: '',
      CreditorBankAccount: '',
      CreditorIdentifier: '',
      DebtorBankAccount: '',
      DebtorIdentifier: '',
      DebtorName: '',
      ImmPmtAccepted: '',
      ModificationAccepted: '',
      PymtNtr: '',
      RemittanceInformation: '',
      RequestedExecutionDate: '',
      draftName: '',
      idAccount: '',
      idDraft: '',
      isComplete: ''
    }
    this.$engine.settings.set({preChargedFile: attachmentObj})
    this.$engine.settings.set({preChargedDraft: draftObj})
  },
  watch: {
    loadingFile (val) {
      if (val) {
        this.$f7.showPreloader('Loading File')
      } else {
        this.$f7.hidePreloader()
      }
    }
  },
  methods: {
    hideBlock ($event) {
      let that = this
      if (that.Dom7($event.target).hasClass('card-header')) {
        if (that.Dom7($event.target).next().css('display') === 'none') {
          that.Dom7($event.target).next().show()
          that.Dom7($event.target).find('i').transform('rotate(90deg)')
        } else {
          that.Dom7($event.target).next().hide()
          that.Dom7($event.target).find('i').transform('rotate(0deg)')
        }
      } else {
        if (that.Dom7($event.target).parent().next().css('display') === 'none') {
          that.Dom7($event.target).parent().next().show()
          that.Dom7($event.target).parent().find('i').transform('rotate(90deg)')
        } else {
          that.Dom7($event.target).parent().next().hide()
          that.Dom7($event.target).parent().find('i').transform('rotate(0deg)')
        }
      }
      // that.$$('.page-content').scrollTop(that.Dom7($event.target).offset().top - that.$$('.page-content').offset().top + that.$$('.page-content').scrollTop() + 300, 400)
      that.$$('.page-content').scrollTop(that.Dom7($event.target).offset().top + that.$$(that.$$('.page-content')[that.$$('.page-content').length - 1]).offset().top - 96, 400)
    },
    setContacts: function () {
      var contactList = {}
      for (var j = 0; j < this.$engine.contacts.get().length; j++) {
        var firstLetter = this.$engine.contacts.get(j).identifier.substr(0, 1).toUpperCase()
        if (!contactList.hasOwnProperty(firstLetter)) {
          contactList[firstLetter] = []
        }
        contactList[firstLetter].push({label: this.$engine.contacts.get(j).label, iban: this.$engine.contacts.get(j).iban, identifier: this.$engine.contacts.get(j).identifier, name: this.$engine.contacts.get(j).name, id: this.$engine.contacts.get(j).id})
        contactList[firstLetter].sort()
      }
      this.contactSelectionList = this.orderKeys(contactList)
    },
    onFileChange (e) {
      let that = this
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) { return }
      if (files[0].size <= 500000) {
        var reader = new FileReader()
        reader.onload = (event) => {
          that.attachement = event.target.result
          if (this.$engine.settings.get().ocrActivation === '1') {
            let requestAlertText = that.$i18n.t('sent.ocr_loading', {request_type: that.$i18n.t('servicesNames.req_to_py_sing')})
            that.$f7.showPreloader(requestAlertText)

            that.$engine.services.payments.invoiceScan(
              that.$engine.user.get().id,
              that.attachementName,
              that.attachement.split(',')[1],
              that.attachement.split(';')[0].split('/')[1],
              'scan'
            ).then(response => {
              if (response.data.reference === '$Error' || response.data.reference === '$NotFound') {
                response.data.reference = Math.floor(Math.random() * Math.floor(3))
              }
              if (response.data.debtorName === '$Error' || response.data.debtorName === '$NotFound') {
                response.data.debtorName = ''
              }
              that.debtorName = response.data.debtorName
              if (response.data.debtorBankAccount === '$Error' || response.data.debtorBankAccount === '$NotFound') {
                response.data.debtorBankAccount = ''
              }
              that.debtorBank = response.data.debtorBankAccount
              if (response.data.debtorEmail === '$Error' || response.data.debtorEmail === '$NotFound') {
                response.data.debtorEmail = ''
              }
              that.debtorEmail = response.data.debtorEmail
              if (response.data.amount === '$Error' || response.data.amount === '$NotFound') {
                response.data.amount = ''
              }
              that.amount = response.data.amount
              if (response.data.reqstdExecDate === '$Error' || response.data.reqstdExecDate === '$NotFound') {
                response.data.reqstdExecDate = ''
              }
              that.executionDate = response.data.reqstdExecDate
              if (response.data.reference === '$Error' || response.data.reference === '$NotFound') {
                response.data.reference = ''
              }
              that.attachementReference = response.data.reference
              // that.attachementName = 'Invoice_' + response.data.reference
              that.$f7.hidePreloader()
              that.Dom7(e.target).parent().parent().parent().parent().parent().parent().parent().parent().find('.card').find('.card-content').show()
              that.Dom7(e.target).parent().parent().parent().parent().parent().parent().parent().parent().find('.card').find('.card-header').find('i').transform('rotate(90deg)')
              that.$f7.modal({
                title: 'OCR finished',
                text: '<span class="preloader"></span>'
              })
              setTimeout(function () {
                that.$f7.hidePreloader()
                that.$f7.closeModal()
                console.log('Timeout reached')
              }, 10000)
            })
            .catch(err => {
              that.$f7.hidePreloader()
              that.$f7.closeModal()
              that.$f7.alert('The OCR did not work because the file is tilted too far. Please reduce the inclination of the file. \n', err)
              console.log('The OCR did not work because the file is tilted too far. Please reduce the inclination of the file. => ' + err)
            })
          }
        }
        reader.readAsDataURL(files[0])
        that.attachementName = files[0].name
        this.Dom7(this.Dom7('.fileNameDisplay')[this.Dom7('.fileNameDisplay').length - 1]).val(this.attachementName)
        // this.Dom7('.fileNameDisplay').text(this.attachementName)
      } else {
        this.$f7.alert('This file has a size of ' + Math.round(files[0].size / 1000) + 'Kb. \n Maximum permited is 500Kb', 'Maximum file size exceeded')
      }
    },
    orderKeys: function (obj, expected) {
      var keys = Object.keys(obj).sort(function keyOrder (k1, k2) {
        if (k1 < k2) return -1
        else if (k1 > k2) return +1
        else return 0
      })
      var i
      var after = {}
      for (i = 0; i < keys.length; i++) {
        after[keys[i]] = obj[keys[i]]
        delete obj[keys[i]]
      }
      for (i = 0; i < keys.length; i++) {
        obj[keys[i]] = after[keys[i]]
      }
      return obj
    },
    switched () {
      this.fromCloud = !this.fromCloud
      this.attachementName = ''
      this.attachement = ''
      this.attachementId = ''
    },
    cloudFileSel () {
      const that = this
      this.loadingFile = true
      this.$engine.attachments.download(that.attachementId.toString())
        .then(response => {
          that.attachementName = response.data.document_name
          that.attachement = response.data.document_data
          that.loadingFile = false
          that.attachementReference = response.data.internal_reference
          that.Dom7('.fileNameDisplay').text(that.attachementName)
        })
        .catch(error => {
          errorMessageAlert(error, that)
        })
    },
    createImage (file) {
      var that = this
      var reader = new FileReader()
      reader.onload = (e) => {
        that.attachement = e.target.result
      }
      reader.readAsDataURL(file)
    },
    removeImage: function (e) {
      this.attachement = ''
    },
    convertDateFormat () {
      this.executionDate = moment(this.executionDate).format('YYYY-MM-DD')
    },
    rotateChevron ($event) {
      if (this.Dom7($event.target).parent().parent().parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().hasClass('accordion-item-expanded')) {
        this.Dom7($event.target).find('i').transform('rotate(0deg)')
      } else {
        this.Dom7($event.target).find('i').transform('rotate(90deg)')
      }
    },
    sendPayments: function () {
      const that = this
      let ImmPmtAcc = this.ImmPmtAccepted ? 'true' : 'false'
      let payNat = this.ImmPmtAccepted ? 'IMMED' : 'TERM'
      let payModAcc = this.modificationAccepted ? 'true' : 'false'
      let debtorsInfo = []
      for (var property in this.selectedDebtors) {
        debtorsInfo.push({
          DebtorName: this.selectedDebtors[property].name,
          DebtorBankAccount: this.selectedDebtors[property].iban,
          DebtorIdentifier: this.selectedDebtors[property].identifier
        })
      }
      for (var debtor in this.enteredDebtors) {
        debtorsInfo.push({
          DebtorName: this.enteredDebtors[debtor].debtorName,
          DebtorBankAccount: this.enteredDebtors[debtor].debtorBank,
          DebtorIdentifier: this.enteredDebtors[debtor].debtorEmail
        })
      }
      let requestAlertText = ''
      let responseAlertText = ''
      if (debtorsInfo.length > 1) {
        requestAlertText = 'Sending Request to Pay'
        responseAlertText = 'Request to Pay Sent'
      } else {
        requestAlertText = 'Sending Request to Pay'
        responseAlertText = 'Request to Pay Sent'
      }
      this.sendPaymentsClicked = true
      let returnFlag = false
      let requestDetailsBlockFlag = false
      let debtorFlag = false
      let creidtorFlag = false
      let remittanceInformationFlag = false
      let executionDateFlag = false
      let amountFlag = false

      if (debtorsInfo.length === 0) {
        that.$$('.recipientBlock').show()
        that.$$('.recipientChevron').transform('rotate(90deg)')
        returnFlag = true
        debtorFlag = true
      }
      if (this.creditorBank === '') {
        that.$$('.myAccountBlock').show()
        that.$$('.senderChevron').transform('rotate(90deg)')
        returnFlag = true
        creidtorFlag = true
      }
      if (this.remittanceInformation === '') {
        requestDetailsBlockFlag = true
        returnFlag = true
        remittanceInformationFlag = true
      }
      if (this.executionDate === '') {
        requestDetailsBlockFlag = true
        returnFlag = true
        executionDateFlag = true
      }
      if (this.amount === '') {
        requestDetailsBlockFlag = true
        returnFlag = true
        amountFlag = true
      }
      if (requestDetailsBlockFlag) {
        that.$$('.requestDetailsBlock').show()
        that.$$('.detailChevron').transform('rotate(90deg)')
      }

      if (debtorFlag && !creidtorFlag && !remittanceInformationFlag && !executionDateFlag && !amountFlag) {
        this.$f7.alert('', 'Debtor missing')
      } else if (!debtorFlag && creidtorFlag && !remittanceInformationFlag && !executionDateFlag && !amountFlag) {
        this.$f7.alert('', 'Creditor missing')
      } else if (!debtorFlag && !creidtorFlag && remittanceInformationFlag && !executionDateFlag && !amountFlag) {
        this.$f7.alert('', 'Reason missing')
      } else if (!debtorFlag && !creidtorFlag && !remittanceInformationFlag && executionDateFlag && !amountFlag) {
        this.$f7.alert('', 'Execution date missing')
      } else if (!debtorFlag && !creidtorFlag && !remittanceInformationFlag && !executionDateFlag && amountFlag) {
        this.$f7.alert('', 'Amount missing')
      } else if (!debtorFlag && !creidtorFlag && !remittanceInformationFlag && !executionDateFlag && !amountFlag) {
      } else {
        this.$f7.alert('', 'Data missing')
      }

      if (returnFlag) {
        return
      }
      this.convertDateFormat()
      this.$f7.showPreloader(requestAlertText)
      that.$engine.services.payments
      .create({
        CreditorIdentifier: this.$engine.user.get().identifier,
        CreditorBankAccount: that.creditorBank,
        CreditorName: this.$engine.user.get().name,
        Debtors: debtorsInfo,
        RemittanceInformation: that.remittanceInformation,
        ImmPmtAccepted: ImmPmtAcc,
        PymtNtr: payNat,
        RequestedExecutionDate: that.executionDate,
        Amount: that.amount,
        ModificationAccepted: payModAcc,
        AttachmentName: that.attachementName,
        AttachmentReference: that.attachementReference,
        AttachmentData: that.attachement
      })
      .then(response => {
        that.status = response.status
        if (response.status === 200) {
          // that.$engine.settings.set({sessionToken: response.headers['x-session-token']})
          that.$bus.$emit('payments-sent')
          that.$f7.hidePreloader()
          this.$f7.modal({
            title: responseAlertText,
            text: '<i class="icon fa fa-check"></i>'
          })
          this.$engine.services.payments.debtorList = []
          this.$engine.services.payments.contactDebtorList = []
          setTimeout(function () {
            that.$f7.closeModal()
            loadPage(that, {url: '/payments/sendbox/'})
          }, 2000)
        }
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    SaveInDraft (namedraft) {
      let that = this
      let payNat = this.ImmPmtAccepted ? 'IMMED' : 'TERM'
      let payModAcc = this.modificationAccepted ? 'true' : 'false'
      let debtorsInfo = []

      for (var property in this.selectedDebtors) {
        debtorsInfo.push({
          DebtorName: this.selectedDebtors[property].name,
          DebtorBankAccount: this.selectedDebtors[property].iban,
          DebtorIdentifier: this.selectedDebtors[property].identifier
        })
      }
      for (var debtor in this.enteredDebtors) {
        debtorsInfo.push({
          DebtorName: this.enteredDebtors[debtor].debtorName,
          DebtorBankAccount: this.enteredDebtors[debtor].debtorBank,
          DebtorIdentifier: this.enteredDebtors[debtor].debtorEmail
        })
      }
      if (debtorsInfo.length === 0) {
        debtorsInfo.push({
          DebtorName: '',
          DebtorBankAccount: '',
          DebtorIdentifier: ''
        })
      }
      this.convertDateFormat()
      let draftArray = []

      if (that.capsule === 'draft-edit') {
        let requestLoad = []
        requestLoad.push({
          'idDraft': this.idDraft,
          'idAccount': this.$engine.user.get().id,
          'CreditorBankAccount': that.creditorBank,
          'CreditorIdentifier': this.$engine.user.get().identifier,
          'CreditorName': this.$engine.user.get().name,
          'DebtorName': this.debtorName,
          'DebtorBankAccount': this.debtorBank,
          'DebtorIdentifier': this.debtorEmail,
          'RemittanceInformation': that.remittanceInformation,
          'ImmPmtAccepted': payModAcc,
          'PymtNtr': payNat,
          'RequestedExecutionDate': that.executionDate,
          'Amount': that.amount,
          'ModificationAccepted': that.modificationAccepted,
          'AttachmentId': that.attachementId,
          'AttachmentName': that.attachementName,
          'AttachmentReference': that.attachementReference,
          'Attachment': that.attachement,
          'DraftName': that.draftName
        })

        this.$engine.drafts.update(requestLoad[0])
        .then(response => {
          if (response.status === 200) {
            this.$f7.modal({
              title: that.saveMessage,
              text: '<span class="preloader"></span>'
            })
            setTimeout(function () {
              that.$f7.closeModal()
              loadPage(that, {url: '/payments/sendbox/draft', force: false, ignoreCache: false})
            }, 2000)
          }
        })
        .catch(err => {
          errorMessageAlert(err, this)
        })
      } else {
        for (var deb in debtorsInfo) {
          draftArray.push({
            'idAccount': this.$engine.user.get().id,
            'CreditorBankAccount': that.creditorBank,
            'CreditorIdentifier': this.$engine.user.get().identifier,
            'CreditorName': this.$engine.user.get().name,
            'DebtorName': debtorsInfo[deb].DebtorName,
            'DebtorBankAccount': debtorsInfo[deb].DebtorBankAccount,
            'DebtorIdentifier': debtorsInfo[deb].DebtorIdentifier,
            'RemittanceInformation': that.remittanceInformation,
            'ImmPmtAccepted': payModAcc,
            'PymtNtr': payNat,
            'RequestedExecutionDate': that.executionDate,
            'Amount': that.amount,
            'ModificationAccepted': that.modificationAccepted,
            'AttachmentId': that.attachementId,
            'AttachmentName': that.attachementName,
            'AttachmentReference': that.attachementReference,
            'Attachment': that.attachement,
            'DraftName': namedraft
          })
        }
        let requestLoad = {
          'drafts': draftArray
        }
        that.$engine.drafts.create(requestLoad)
        .then(response => {
          if (response.status === 200) {
            this.$f7.modal({
              title: that.saveMessage,
              text: '<span class="preloader"></span>'
            })
            setTimeout(function () {
              that.$f7.closeModal()
              loadPage(that, {url: '/payments/sendbox/draft', force: false, ignoreCache: false})
            }, 2000)
          }
        })
        .catch(error => {
          errorMessageAlert(error, that)
        })
      }
    },
    getNameDraft () {
      var namedraft = ''
      let that = this
      if (this.capsule === 'draft-create' || this.capsule === 'direct-payment-create') {
        this.$f7.modal({
          title: 'Please enter a name for your draft',
          // text: 'Enter a name of draft',
          afterText: '<div class="item-input"><input class="inputnamedraft" type="text"></div>',
          buttons: [
            {
              text: 'Cancel',
              color: 'red',
              onClick: function () {
              }
            },
            {
              text: 'Save',
              onClick: function () {
                let namedraft = that.Dom7('.inputnamedraft').val()
                that.SaveInDraft(namedraft)
              }
            }
          ]
        })
      } else {
        this.SaveInDraft(namedraft)
      }
    },
    sendDirectPayments: function () {
      const that = this
      let ImmPmtAcc = this.ImmPmtAccepted ? 'true' : 'false'
      let payNat = this.ImmPmtAccepted ? 'IMMED' : 'TERM'
      let payModAcc = this.modificationAccepted ? 'true' : 'false'
      let debtorsInfo = []
      for (var property in this.selectedDebtors) {
        debtorsInfo.push({
          CreditorName: this.selectedDebtors[property].name,
          CreditorBankAccount: this.selectedDebtors[property].iban,
          CreditorIdentifier: this.selectedDebtors[property].identifier
        })
      }
      for (var debtor in this.enteredDebtors) {
        debtorsInfo.push({
          CreditorName: this.enteredDebtors[debtor].debtorName,
          CreditorBankAccount: this.enteredDebtors[debtor].debtorBank,
          CreditorIdentifier: this.enteredDebtors[debtor].debtorEmail
        })
      }
      let requestAlertText = 'Sending Request to Pay'
      let responseAlertText = 'Request to Pay Sent'
      this.sendPaymentsClicked = true
      let returnFlag = false
      let requestDetailsBlockFlag = false
      let debtorFlag = false
      let creidtorFlag = false
      let remittanceInformationFlag = false
      let executionDateFlag = false
      let amountFlag = false

      if (debtorsInfo.length === 0) {
        that.$$('.recipientBlock').show()
        that.$$('.recipientChevron').transform('rotate(90deg)')
        // this.$f7.alert('', 'Debtor missing')
        // return
        returnFlag = true
        debtorFlag = true
      }
      if (this.creditorBank === '') {
        that.$$('.myAccountBlock').show()
        that.$$('.senderChevron').transform('rotate(90deg)')
        returnFlag = true
        creidtorFlag = true
      }
      if (this.remittanceInformation === '') {
        requestDetailsBlockFlag = true
        returnFlag = true
        remittanceInformationFlag = true
      }
      if (this.executionDate === '') {
        requestDetailsBlockFlag = true
        returnFlag = true
        executionDateFlag = true
      }
      if (this.amount === '') {
        requestDetailsBlockFlag = true
        returnFlag = true
        amountFlag = true
      }
      if (requestDetailsBlockFlag) {
        that.$$('.requestDetailsBlock').show()
        that.$$('.detailChevron').transform('rotate(90deg)')
      }

      if (debtorFlag && !creidtorFlag && !remittanceInformationFlag && !executionDateFlag && !amountFlag) {
        this.$f7.alert('', 'Creditor missing')
      } else if (!debtorFlag && creidtorFlag && !remittanceInformationFlag && !executionDateFlag && !amountFlag) {
        this.$f7.alert('', 'Debtor missing')
      } else if (!debtorFlag && !creidtorFlag && remittanceInformationFlag && !executionDateFlag && !amountFlag) {
        this.$f7.alert('', 'Reason missing')
      } else if (!debtorFlag && !creidtorFlag && !remittanceInformationFlag && executionDateFlag && !amountFlag) {
        this.$f7.alert('', 'Execution date missing')
      } else if (!debtorFlag && !creidtorFlag && !remittanceInformationFlag && !executionDateFlag && amountFlag) {
        this.$f7.alert('', 'Amount missing')
      } else if (!debtorFlag && !creidtorFlag && !remittanceInformationFlag && !executionDateFlag && !amountFlag) {
      } else {
        this.$f7.alert('', 'Data missing')
      }

      if (returnFlag) {
        return
      }
      this.convertDateFormat()

      this.$f7.showPreloader(requestAlertText)
      that.$engine.services.payments
      .paymentsPain001({
        Creditors: debtorsInfo,
        DebtorName: this.$engine.user.get().name,
        DebtorBankAccount: that.creditorBank,
        DebtorIdentifier: this.$engine.user.get().identifier,
        RemittanceInformation: that.remittanceInformation,
        ImmPmtAccepted: ImmPmtAcc,
        PymtNtr: payNat,
        RequestedExecutionDate: that.executionDate,
        Amount: that.amount,
        ModificationAccepted: payModAcc,
        AttachmentName: that.attachementName,
        AttachmentReference: that.attachementReference,
        AttachmentData: that.attachement
      })
      .then(response => {
        that.status = response.status
        if (response.status === 200) {
          // that.$engine.settings.set({sessionToken: response.headers['x-session-token']})
          that.$bus.$emit('payments-sent')
          that.$f7.hidePreloader()
          this.$f7.modal({
            title: responseAlertText,
            text: '<i class="icon fa fa-check"></i>'
          })
          this.$engine.services.payments.debtorList = []
          this.$engine.services.payments.contactDebtorList = []
          setTimeout(function () {
            that.$f7.closeModal()
            loadPage(that, {url: '/payments/sendbox/'})
          }, 2000)
        }
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    accountPicker (e) {
      e.stopPropagation()
      this.accountsPicker.open()
    },
    filesPicker (e) {
      e.stopPropagation()
      // if (this.loadingFile === true || !this.fromCloud) { return }
      this.cloudDocsPicker.open()
    },
    debtorPicker (e) {
      e.stopPropagation()
      if (this.loadingFile === true) { return }
      this.contactsPicker.open()
    },
    addDebtor () {
      if (this.debtorName === '') {
        this.$f7.alert('', 'Debtor name invalid')
        return
      }
      if (this.debtorBank.length > 0) {
        if (validateIBAN(this.debtorBank) === null) {
          this.$f7.alert('', 'Debtor bank invalid')
          return
        }
      }
      if (this.debtorEmail === '') {
        this.$f7.alert('', 'Debtor email invalid')
        return
      }
      this.$engine.services.payments.debtorList.push({
        debtorName: this.debtorName,
        debtorBank: this.debtorBank,
        debtorEmail: this.debtorEmail
      })
      this.debtorName = ''
      this.debtorBank = ''
      this.debtorEmail = ''
    },
    openCreateAttachmentInvoice () {
      loadPage(this, {url: '/attachments/createInvoice/'})
    },
    openImportAttachmentInvoice () {
      let that = this
      let buttons1 = [
        {
          text: 'Import from device',
          onClick: function () {
            that.attachement = ''
            that.attachementName = ''
            that.attachementId = ''
            that.Dom7(that.Dom7('.local-file-input')[that.Dom7('.local-file-input').length - 1]).click()
          }
        }
      ]
      if (this.hasCloudAttachments) {
        buttons1.push({
          text: 'Import from MoneyRoad',
          onClick: function (event, event2) {
            that.attachement = ''
            that.attachementName = ''
            that.attachementId = ''
            that.filesPicker(event2)
          }
        })
      }
      let buttons2 = [
        {
          text: 'Cancel',
          color: 'red',
          onClick: function () {
          }
        }
      ]
      this.$f7.actions([buttons1, buttons2])
    },
    calendar ($event) {
      /* eslint-disable no-undef */
      let that = this

      if (that.$f7.device.os === 'android' || that.$f7.device.os === 'ios') {
        var options = {
          date: new Date(),
          mode: 'date'
        }
        datePicker.show(options, function (date) {
          let year = date.getFullYear().toString()
          let month = (date.getMonth() + 1).toString().length > 1 ? (date.getMonth() + 1).toString() : '0' + (date.getMonth() + 1).toString()
          let day = date.getDate().toString().length > 1 ? date.getDate().toString() : '0' + date.getDate().toString()
          let dateResult = year + '-' + month + '-' + day
          that.executionDate = dateResult
        })
      } else {
      }
      /* eslint-enable no-undef */
    },
    paymentsDate () {
      if (this.executionDate !== undefined) {
        if (this.executionDate.length > 0) {
          return this.executionDate
        } else {
          return 'Select a date'
        }
      } else {
        return 'Select a date'
      }
    },
    clearInvoice () {
      this.attachement = ''
      this.attachementName = ''
      this.attachementReference = ''
      this.attachementId = ''
    },
    scanInvoice ($event) {
      /* eslint-disable no-undef */
      let that = this
      var options = {
        quality: 10,
        destinationType: Camera.DestinationType.FILE_URI,
        sourceType: Camera.PictureSourceType.CAMERA,
        encodingType: Camera.EncodingType.JPEG,
        mediaType: Camera.MediaType.PICTURE,
        allowEdit: true,
        correctOrientation: true
      }

      navigator.camera.getPicture(function cameraSuccess (imageUri) {
        window.resolveLocalFileSystemURL(imageUri, function (entry) {
          entry.file(function (file) {
            var reader = new FileReader()

            reader.onloadend = function (e) {
              let requestAlertText = that.$i18n.t('sent.ocr_loading', {request_type: that.$i18n.t('servicesNames.req_to_py_sing')})
              that.$f7.showPreloader(requestAlertText)

              /* TLV 30/06/2020 : FAUX OCR EN DUR POUR DEMO */
              setTimeout(function () {
                that.debtorName = 'Robert Alexandre'
                that.debtorBank = 'FR7414508000405615775438R72'
                that.creditorBankName = 'My Bank Account'
                that.debtorEmail = 'robert.alexandre@streammind.com'
                that.amount = '4800'
                that.remittanceInformation = 'Application Entreprise StreamMind'
                that.modificationAccepted = true
                that.$f7.hidePreloader()
                that.$f7.closeModal()
                console.log('Timeout reached')
              }, 1000)
              /* TLV 30/06/2020 : DECOMMENTER LES LIGNES CI-DESSOUS QUAND L'OCR MARCHERA VRAIMENT */
              /* that.$engine.services.ocr(
                that.$engine.user.get().id,
                '',
                e.target.result.split(',')[1],
                'jpeg',
                'scan',
                'Invoice'
              ).then(response => {
                if (response.data.debtorName === '$Error' || response.data.debtorName === '$NotFound') {
                  response.data.debtorName = ''
                }
                that.debtorName = response.data.debtorName
                if (response.data.debtorBankAccount === '$Error' || response.data.debtorBankAccount === '$NotFound') {
                  response.data.debtorBankAccount = ''
                }
                that.debtorBank = response.data.debtorBankAccount
                if (response.data.debtorEmail === '$Error' || response.data.debtorEmail === '$NotFound') {
                  response.data.debtorEmail = ''
                }
                that.debtorEmail = response.data.debtorEmail
                if (response.data.amount === '$Error' || response.data.amount === '$NotFound') {
                  response.data.amount = ''
                }
                that.amount = response.data.amount
                if (response.data.reqstdExecDate === '$Error' || response.data.reqstdExecDate === '$NotFound') {
                  response.data.reqstdExecDate = ''
                }
                that.executionDate = response.data.reqstdExecDate
                if (response.data.reference === '$Error' || response.data.reference === '$NotFound') {
                  response.data.reference = ''
                }
                that.attachementReference = response.data.reference
                // that.attachementName = 'Invoice_' + response.data.reference

                that.attachementName = 'IMG_' + Math.floor(Math.random() * Math.floor(3)) + '.JPEG'
                that.attachement = e.target.result
                that.$f7.hidePreloader()
                that.Dom7($event.target).parent().find('.card').find('.card-content').show()
                that.Dom7($event.target).parent().find('.card').find('.card-header').find('i').transform('rotate(90deg)')
                that.$f7.modal({
                  title: 'OCR finished',
                  text: '<span class="preloader"></span>'
                })
                setTimeout(function () {
                  that.$f7.hidePreloader()
                  that.$f7.closeModal()
                  console.log('Timeout reached')
                }, 10000)
              })
              .catch(err => {
                that.$f7.hidePreloader()
                that.$f7.closeModal()
                that.$f7.alert('The OCR did not work because the file is tilted too far. Please reduce the inclination of the file. \n', err)
                console.log('The OCR did not work because the file is tilted too far. Please reduce the inclination of the file. => ' + err)
              }) */
            }
            reader.readAsDataURL(file)
          }, function () {
            console.log('Error: Creating File object error.')
          })
        }, function () {
          console.log('Error: Resolving URL error.')
        })
      }, function cameraError (error) {
        console.debug('Unable to obtain picture: ' + error, 'app')
      }, options)
      /* eslint-enable no-undef */
    },
    // QR Code Scan and Read
    generateQRCode () {
      // var canvas = document.getElementById('qrcodeCanvas')

      // qrcode.toCanvas(canvas, 'sample text', function (error) {
      //   if (error) console.error(error)
      //   console.log('success!')
      // })
    },
    readQRCode () {
      /* eslint-disable no-undef */
      let that = this
      window.QRScanner.prepare(function (err, status) {
        if (err) {
          // here we can handle errors and clean up any loose ends.
          console.log(err)
        }
        if (status.authorized) {
          // W00t, you have camera access and the scanner is initialized.
          // QRscanner.show() should feel very fast.
          that.Dom7('html').css('opacity', '0')
          window.QRScanner.show(function (status) {
            window.QRScanner.scan(function (err, text) {
              if (err) {
                // an error occurred, or the scan was canceled (error code `6`)
                console.log(err)
                that.Dom7('html').css('opacity', '1')
              } else {
                // The scan completed, display the contents of the QR code:
                alert(text)
                console.log(text)
                that.Dom7('html').css('opacity', '1')
              }
            })
          })
        } else if (status.denied) {
          // The video preview will remain black, and scanning is disabled. We can
          // try to ask the user to change their mind, but we'll have to send them
          // to their device settings with `QRScanner.openSettings()`.
          console.log('--------prepare denied--------')
        } else {
          // we didn't get permission, but we didn't get permanently denied. (On
          // Android, a denial isn't permanent unless the user checks the "Don't
          // ask again" box.) We can ask again at the next relevant opportunity.
          console.log('--------prepare else--------')
        }
      })
      /* eslint-enable no-undef */
    },
    importRIB ($event) {
      this.Dom7(this.Dom7('.rib-file-input')[this.Dom7('.rib-file-input').length - 1]).click()
    },
    executeOCROnRIB (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) { return }
      if (files[0].size <= 50000000) {
        let that = this
        var reader = new FileReader()
        reader.onload = (e) => {
          that.executeOCR('RIB', e.target.result)
        }
        return reader.readAsDataURL(files[0])
      } else {
        this.$f7.alert('This file has a size of ' + Math.round(files[0].size / 1000) + 'Kb. \n Maximum permited is 50Mo', 'Maximum file size exceeded')
      }
    },
    /** @author ERI- TLV
    * @date 27/03/2020
    * @brief méthode qui execute l'OCR à partir de l'Order transmis en paramètre
    *     et qui affiche les données retournées sur l'IHM
    * @param filetype may be: RIB, Invoice, Order
    * @param file est l'image chiffrée en base64
    */
    executeOCR (filetype, file) {
      let that = this
      // key : IHM reception parameter, value : OCR returned data
      let exchangeData = {
        'RIB': {
          debtorBank: 'iban',
          debtorName: 'name'
        }
      }
      that.$f7.showPreloader(that.$i18n.t('sent.ocr_loading', {request_type: that.$i18n.t('servicesNames.req_to_py_sing')}))
      return that.$engine.services.ocr(
        that.$engine.user.get().id,
        '',
        file,
        'jpeg',
        'scan',
        filetype
      ).then(response => {
        that.$f7.hidePreloader()
        that.$f7.modal({
          title: that.$i18n.t('sent.ocr_end'),
          text: '<span class="preloader"></span>'
        })
        that.$f7.hidePreloader()
        that.$f7.closeModal()
        response = response.data
        // Pour l'instant l'OCR ne marche qu'avec des IBAN
        this.debtorZoneCode = this.$engine.bankAccounts.getZoneData('EU')
        for (var key in exchangeData[filetype]) {
          if (response[exchangeData[filetype][key]] === '$Error' ||
              response[exchangeData[filetype][key]] === '$NotFound') {
            response[exchangeData[filetype][key]] = ''
          }
          that[key] = response[exchangeData[filetype][key]]
        }
      })
      .catch(err => {
        that.$f7.hidePreloader()
        that.$f7.closeModal()
        alert(that.$i18n.t('errors.too_important_tilt') + ' ' + err)
        console.log(that.$i18n.t('errors.too_important_tilt') + ' ' + err)
      })
    }
  }
}
</script>
<style scoped>

#cloud-label {
  color: #12bcf1;
  width: 30%;
  background-color: #e6e7e8;
padding: 3px 3px 3px 3px;
  text-align: center;
  display: inline-block;
  border-style: solid;
  border-width: 1px;
  border-radius: 5px;
  border-color: #12bcf1;
}
.test-content{
  border-style: solid;
  border-width: 1px;
  border-color: #EBEBED;

	min-height: 15px;

	box-sizing: border-box;
  padding-left: 15px;
  display: flex;
  -webkit-box-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  align-items: center;
}
.test-inner{
  min-height: 15px;
  padding-right: 15px;
  position: relative;
  width: 100%;
  padding-top: 8px;
  padding-bottom: 7px;

  box-sizing: border-box;
  display: flex;
  -webkit-box-flex: 1;

  overflow: hidden;
  -webkit-box-pack: justify;
  justify-content: space-between;
  -webkit-box-align: center;
  align-items: center;
  align-self: stretch;
}
.test-title{
  color: #0E0144;
  flex-shrink: 1;
  min-width: 0;
  white-space: nowrap;
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}
.test-after{
  max-width: 70%;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
  display: block;
  white-space: nowrap;
  color: #8e8e93;
  flex-shrink: 0;
  margin-left: auto;
  padding-left: 5px;
  max-height: 28px;
}
.grayEmpty{
  background-color: #f7f7f7;
}
.subtitleDebtorList {
  /* font-size: 14px; */
  /* font-weight: bold; */
  color: #000000;
}
.paymentsRequestSubOption {
  font-size: 14px;
}
.paymentsRequestSubOption input::-webkit-input-placeholder {
  font-size: 14px;
}
.formLabelPayment{
    min-width: 65px !important;
    width: 40% !important;
    font-size: 12px;
}
.paymentsRequestAddOtherDebtor {
  position: relative !important;
  color: #777777;
}
.negotiateSwitch {
  width: auto !important;
  margin-right: 30px;
}
.formTitle {
  color:white !important;
  text-align: center;
  margin: auto;
}
.facturePart2 {
  color: black;
}
.custom-item-inner {
  width: 100%;
  padding: 8px 15px 7px 0px;
}
.invoiceButton {
  min-width: 80px;
}
.Column50 {
  width: 50% !important;
}
.paymentsButtonLength {
  /* padding: 0px 30.5px; */
  width: 113px;
}
.label-switch {
  float: right;
}
</style>



// WEBPACK FOOTER //
// PRCreateTemplate.vue?3226418a